module.exports = __webpack_public_path__ + "static/img/方胜磐石的三Q精神背景@2x.1d2fcb1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/方胜磐石的三Q精神背景@2x.png
// module id = D9w/
// module chunks = 0